import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dobuleArrowUp",
  "use": "icon-dobuleArrowUp-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dobuleArrowUp\"><defs><style type=\"text/css\"></style></defs><path d=\"M231.5 577.4L512 296.9l280.5 280.5c5.9 5.9 13.5 8.8 21.2 8.8s15.4-2.9 21.2-8.8c11.7-11.7 11.7-30.7 0-42.4L533.2 233.2c-11.7-11.7-30.7-11.7-42.4 0L189 535c-11.7 11.7-11.7 30.7 0 42.4 11.8 11.7 30.8 11.7 42.5 0zM835 748.3L533.2 446.6c-11.7-11.7-30.7-11.7-42.4 0L189 748.3c-11.7 11.7-11.7 30.7 0 42.4s30.7 11.7 42.4 0L512 510.2l280.5 280.5c5.9 5.9 13.5 8.8 21.2 8.8s15.4-2.9 21.2-8.8c11.8-11.7 11.8-30.7 0.1-42.4z\" p-id=\"1063\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-dobuleArrowUp.svg
// module id = 7fwJ
// module chunks = 3